<template>

  <div class="account-registration body-wrap boxed-container">
    <div class="container-herohire">
      <v-app dark>

        <Header/>
        <RegisterHeader/>
        <RegisterForm/>
      </v-app>

    </div>
    <Footer/>

  </div>
</template>

<script>
import RegisterHeader from '@/components/Registration/RegisterHeader';
import Header from '@/components/Homepage/Header';
import RegisterForm from '@/components/Registration/RegisterForm';

export default {
  components: {RegisterHeader, Header, RegisterForm}
}
</script>

<style scoped>

</style>
